// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2f$Linear from "./V2f.res.js";
import * as Rect$Linear from "./Rect.res.js";

let zero = {
  pos: V2f$Linear.zero,
  size: V2f$Linear.zero
};

function fromSize(size) {
  return {
    pos: [
      0,
      0
    ],
    size: size
  };
}

function contains(param, point) {
  let match = param.size;
  let match$1 = V2f$Linear.minus(point, param.pos);
  let y = match$1[1];
  let x = match$1[0];
  if (x >= 0 && x <= match[0] && y >= 0) {
    return y <= match[1];
  } else {
    return false;
  }
}

function bounds(param) {
  let pos = param.pos;
  return [
    pos,
    V2f$Linear.plus(pos, param.size)
  ];
}

function clamp(rect, param) {
  let match = bounds(rect);
  let match$1 = match[1];
  let match$2 = match[0];
  return [
    Math.max(match$2[0], Math.min(match$1[0], param[0])),
    Math.max(match$2[1], Math.min(match$1[1], param[1]))
  ];
}

function scaleCenter(param, factor) {
  let size = param.size;
  return {
    pos: V2f$Linear.minus(param.pos, V2f$Linear.scale(size, (factor - 1) / 2)),
    size: V2f$Linear.scale(size, factor)
  };
}

function rotate90(param) {
  let match = param.size;
  let w = match[0];
  let match$1 = param.pos;
  return {
    pos: [
      match$1[1],
      match$1[0] - w
    ],
    size: [
      match[1],
      w
    ]
  };
}

function rotate180(param) {
  let match = param.size;
  let h = match[1];
  let w = match[0];
  let match$1 = param.pos;
  return {
    pos: [
      -1 * (match$1[0] + w),
      -1 * (match$1[1] + h)
    ],
    size: [
      w,
      h
    ]
  };
}

function rotate270(param) {
  let match = param.size;
  let h = match[1];
  let match$1 = param.pos;
  return {
    pos: [
      -1 * (match$1[1] + h),
      -1 * match$1[0]
    ],
    size: [
      h,
      match[0]
    ]
  };
}

function center(param) {
  return V2f$Linear.plus(param.pos, V2f$Linear.scale(param.size, 0.5));
}

function points(param) {
  let match = param.size;
  let h = match[1];
  let w = match[0];
  let match$1 = param.pos;
  let y = match$1[1];
  let x = match$1[0];
  return [
    [
      x,
      y
    ],
    [
      x + w,
      y
    ],
    [
      x + w,
      y + h
    ],
    [
      x,
      y + h
    ]
  ];
}

let jsonCodec = Rect$Linear.jsonCodec(Jzon.float);

export {
  zero,
  fromSize,
  contains,
  bounds,
  clamp,
  scaleCenter,
  rotate90,
  rotate180,
  rotate270,
  center,
  points,
  jsonCodec,
}
/* jsonCodec Not a pure module */
